import { createPathForRoute, RECAP_ROUTE, createDataEntryRouteWithStep } from '../constants/baseRoutePaths';

type getUrlProps = {
  direction: string;
  step: number;
  totalSteps: number;
  isCarrierEnabled: boolean;
};

export function getUrl({ direction, step, totalSteps, isCarrierEnabled }: getUrlProps) {
  const nextStep = direction === 'next' ? step + 2 : step;
  const isRecap = (step === totalSteps - 1 && !isCarrierEnabled) || (step === totalSteps && isCarrierEnabled);
  if (direction === 'next') {
    return createPathForRoute(isRecap ? RECAP_ROUTE : createDataEntryRouteWithStep(nextStep));
  }
  return createPathForRoute(createDataEntryRouteWithStep(step));
}
